/**
 * Potrivire de text pe înțelesul omului: fără diacritice, fără majuscule.
 *
 * Trăia în ecranul de import al catalogului, unde a apărut prima dată. Mutat
 * aici la al doilea consumator (alegerea articolului de catalog din parc) —
 * aceeași regulă ca la `um()` și la etichetele de stare: o funcție care
 * trăiește într-un singur ecran e copiată la al doilea, iar cele două copii
 * divergează. Cineva scrie „Detector PIR" și nu găsește „detector pir".
 */
import { locale } from "./i18n.js";

export function normalizeaza(text) {
  return String(text ?? "").trim().toLowerCase()
    .normalize("NFD").replace(/[̀-ͯ]/g, "");
}

/**
 * Data, în formatul locului: 15.01.2029 în română, 15/01/2029 în engleză —
 * niciodată 2029-01-15, care nu e formatul nimănui.
 *
 * Era scrisă de treisprezece ori, în DOUĂ feluri: șapte ecrane tăiau șirul
 * ISO (`slice(0, 10)`), șase îl treceau prin `toLocaleDateString`. Rezultatul
 * se vedea: aceeași dată arăta altfel în Parc decât în Garanții, în aceeași
 * aplicație, pe același rând de echipament. Nu e o preferință de stil — e
 * exact felul în care un ajutor copiat divergează.
 */
export const data = (v) => (v ? new Date(v).toLocaleDateString(locale()) : "—");

/** Data cu ora, pentru momente: 15.01.2029, 14:06. */
export const dataOra = (v) => (v ? new Date(v).toLocaleString(locale(), {
  day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
}) : "—");

/** Doar ora, unde ziua e deja spusă de context. */
export const ora = (v) => (v
  ? new Date(v).toLocaleTimeString(locale(), { hour: "2-digit", minute: "2-digit" })
  : "—");
